
const digest = '37b200813b031dd87c3263b3b0b86c076fa3f4171e670334cad60564cd3d07e6';
const classes = {"removeButton":"_removeButton_174m5_1"};
const css = `._removeButton_174m5_1 {
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-end;
  font-size: 12px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  